import { styled } from "@mui/material/styles";
import Typography from "@mui/material/Typography";
import { paneIsCompact } from "work/_views/work-pane-layout";

/**
 * One labeled field of a work agreement's Details tab: a title, then its value.
 *
 * Shared with the History field's sentences in `WorkAgreementRevisionLinks`, so that every value on
 * the tab is drawn in one size. The History sentences were once small secondary captions, and read
 * as a footnote rather than as the field's value (#6756).
 */
export const Field = styled("div")(({ theme }) => ({
  [paneIsCompact(theme)]: {
    width: "100%",
  },
  display: "flex",
  flexDirection: "column",
  marginBottom: theme.spacing(3),
  width: "50%",
}));
export const FieldTitle = styled(Typography)(({ theme }) => ({
  color: theme.palette.text.secondary,
  fontSize: "1.2rem",
}));
export const FieldValue = styled(Typography)(() => ({
  fontSize: "1.2rem",
}));
